import $ from 'jquery'
import FileUpload from './FileUpload'

export const initializeStyler = () => {
  // jq checkbox
  $('.jq-checkbox input:checkbox').each(function() {
    $(this).styler()
  })
  // styles select and input
  $('.select').each(function() {
    $(this).styler({ selectPlaceholder: undefined })
  })
}

export const initializeFileUpload = () => {
  $('.JS-FileUpload:not(.JS-Ready)').each(function() {
    new FileUpload($(this)) // eslint-disable-line no-new
    $(this).addClass('JS-Ready')
  })
}

export default () => {
  initializeStyler()
  initializeFileUpload()
}
